export * from './src/bookings-availability-v1-slot-availability-availability-calendar.schemas.js';
